
import { defineComponent } from "vue";
import { colorSchemes } from "@/util/ColorScheme";

export default defineComponent({
  props: {
    schemes: {
      type: Array,
      default: () => Object.keys(colorSchemes),
    },
    modelValue: {
      default: "Soft rainbow",
    },
  },
  emits: ["update:modelValue"],
  data() {
    return { activeScheme: this.modelValue };
  },
  computed: {
    schemesList() {
      return (this.schemes as string[]).map((k: string) => colorSchemes[k]);
    },
  },
  watch: {
    value() {
      this.activeScheme = this.modelValue;
    },
  },
});
